module.exports = __webpack_public_path__ + "assets/twitter.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/twitter.svg
// module id = 762
// module chunks = 0